// components/admin/accounting/modals/DepositadoModal.jsx
import React from 'react';
import { X } from 'lucide-react';

function DepositadoModal({ 
  isOpen, 
  amount, 
  onAmountChange, 
  onSave, 
  onCancel 
}) {
  function formatCurrency(value) {
    if (value === null || value === undefined || value === '') return 'S/ 0.00';
    return `S/ ${Number(value).toFixed(2)}`;
  }

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-xl p-6 shadow-2xl max-w-md w-full mx-4">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-xl font-bold text-slate-800 font-montserrat">
            Monto Depositado
          </h3>
          <button
            onClick={onCancel}
            className="text-slate-400 hover:text-slate-600 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mb-6">
          <label className="block text-sm font-semibold text-slate-700 mb-2 font-montserrat">
            Ingresa el monto depositado (S/)
          </label>
          <input
            type="number"
            value={amount}
            onChange={(e) => onAmountChange(e.target.value)}
            step="0.01"
            min="0"
            placeholder="0.00"
            className="w-full px-4 py-3 text-lg border-2 border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-brand-primary focus:border-transparent font-montserrat"
            autoFocus
          />
          <p className="text-sm text-slate-500 mt-2 font-montserrat">
            Monto a depositar: {formatCurrency(amount)}
          </p>
        </div>

        <div className="flex gap-3">
          <button
            onClick={onCancel}
            className="flex-1 px-4 py-3 bg-slate-200 text-slate-700 rounded-lg hover:bg-slate-300 transition-all font-montserrat font-semibold"
          >
            Cancelar
          </button>
          <button
            onClick={onSave}
            className="flex-1 px-4 py-3 bg-brand-green text-white rounded-lg hover:bg-brand-green/90 transition-all font-montserrat font-semibold"
          >
            Confirmar
          </button>
        </div>
      </div>
    </div>
  );
}

export default DepositadoModal;